// Locally optimized (<100KB) versions of large site images.
// Shape matches the `.asset.json` modules ({ url }) so call sites stay unchanged.
import houseWashingHeroUrl from "./service-house-washing.webp";
import concreteCleaningHeroUrl from "./service-concrete-cleaning-sealing.webp";
import commercialWashingHeroUrl from "./service-commercial-pressure-washing.webp";
import paverCliftonParkHeroUrl from "./service-paver-cleaning-sealing-clifton-park.webp";
import houseWashBeforeUrl from "./house-wash-before.webp";
import houseWashAfterUrl from "./house-wash-after.webp";
import roofWashBeforeUrl from "./roof-wash-before.webp";
import roofWashAfterUrl from "./roof-wash-after.webp";
import paverGlossUrl from "./paver-finish-gloss.webp";
import paverUltraUrl from "./paver-finish-ultra.webp";
import paverInvisibleUrl from "./paver-finish-invisible.webp";
import paverMatteUrl from "./paver-finish-matte.webp";

export const houseWashingHeroOpt = { url: houseWashingHeroUrl };
export const concreteCleaningHeroOpt = { url: concreteCleaningHeroUrl };
export const commercialWashingHeroOpt = { url: commercialWashingHeroUrl };
export const paverCliftonParkHeroOpt = { url: paverCliftonParkHeroUrl };
export const houseWashBeforeOpt = { url: houseWashBeforeUrl };
export const houseWashAfterOpt = { url: houseWashAfterUrl };
export const roofWashBeforeOpt = { url: roofWashBeforeUrl };
export const roofWashAfterOpt = { url: roofWashAfterUrl };
export const paverGlossOpt = { url: paverGlossUrl };
export const paverUltraOpt = { url: paverUltraUrl };
export const paverInvisibleOpt = { url: paverInvisibleUrl };
export const paverMatteOpt = { url: paverMatteUrl };
